//@flow
import type {StateType} from '../reducers';
import type {SimResourceType} from './actions';

export const esimProductSelector = (state: StateType) => {
  return state.signUp.esimProduct;
};

export const simResourceSelector = (state: StateType): ?SimResourceType => {
  return state.signUp.esimProduct?.simResource;
};

export const esimSerialNumberSelector = (state: StateType): ?string => {
  return state.signUp.esimProduct?.simResource?.resourceSerialNumber;
};

export const eSimProductPriceSelector = (state: StateType): ?number => {
  return state.signUp.esimProduct && state.signUp.esimProduct.price;
};

export const eSimProductChooseEsimRouteNameSelector = (
  state: StateType,
): ?string => {
  return (
    state.signUp.esimProduct && state.signUp.esimProduct.chooseEsimRouteName
  );
};

export const eSimCompatibleSelector = (state: StateType): ?Boolean => {
  return state.signUp.esimProduct && state.signUp.esimProduct.isEsimCompatible;
};

export const eSimSelectedSelector = (state: StateType): ?Boolean => {
  return state.signUp.esimProduct && state.signUp.esimProduct.eSimSelected;
};
